export { ViewInstrumentation } from './instrumentation';
